module.exports = __webpack_public_path__ + "static/media/zapier-logo-transparent.1a309867.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zapier-logo-transparent.png
// module id = 1027
// module chunks = 0